import React from 'react'
import LiveWidgetTemplate from 'src/components/template/live-widget'

export default (props) => {
  return <LiveWidgetTemplate location={props.location} lang="en" market="all" />
}
